/* Genuine footage loads only on request; playback stays in native controls. */
(function () {
  'use strict';

  // Merged home (Oct 9): body.ev-lock while a sheet is open, so live's 15% pop-up (blockedByPage) waits and the
  // page does not scroll behind it. Released only when no other EVERLA panel or atelier dialog is still open.
  const LOCK_PANELS = '.ev-cart.is-open,.ev-drawer.is-open,.ev-search.is-open,.ev-modal.is-open,.ev-filters.is-open,dialog.at-quick-shop[open],dialog.at-material-film__dialog[open]';
  function holdLock() { document.body.classList.add('ev-lock'); }
  function releaseLock() { if (!document.querySelector(LOCK_PANELS)) document.body.classList.remove('ev-lock'); }

  function mount(component) {
    if (component.dataset.materialFilmReady === 'true') return;
    const trigger = component.querySelector('[data-material-film-trigger]');
    const dialog = component.querySelector('[data-material-film-dialog]');
    const close = component.querySelector('[data-material-film-close]');
    const video = component.querySelector('[data-material-film-video]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function' || !close || !video) return;
    let backdropStart = false;

    function pause() { if (!video.paused) video.pause(); }
    function dismiss() {
      pause();
      if (dialog.open) dialog.close();
      releaseLock();
    }
    function outside(event) {
      const bounds = dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    }

    trigger.addEventListener('click', function (event) {
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (dialog.open) return;
      const commerce = window.EVERLAv2;
      // A pending add will open the cart; keep its confirmation above the page.
      if (commerce && typeof commerce.isPurchasePending === 'function' && commerce.isPurchasePending()) return;
      if (!video.getAttribute('src')) {
        video.setAttribute('src', trigger.href);
        if (video.dataset.materialFilmPoster) video.setAttribute('poster', video.dataset.materialFilmPoster);
        video.load();
      }
      dialog.showModal();
      holdLock();
      trigger.setAttribute('aria-expanded', 'true');
      close.focus({ preventScroll: true });
    });
    close.addEventListener('click', dismiss);
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      dismiss();
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dismiss();
    });
    dialog.addEventListener('close', function () {
      if (dialog.open) return;
      releaseLock();
      pause();
      trigger.setAttribute('aria-expanded', 'false');
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('pointerdown', function (event) {
      backdropStart = event.target === dialog && outside(event);
    });
    dialog.addEventListener('click', function (event) {
      if (backdropStart && event.target === dialog && outside(event)) dismiss();
      backdropStart = false;
    });

    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', 'false');
    component.dataset.materialFilmReady = 'true';
  }

  function mountAll() { document.querySelectorAll('[data-material-film]').forEach(mount); }
  mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();
